// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"4e099980","564":"3ccbea5b","589":"a9586676"}[chunkId] + ".chunk.js";
};